import { NotificationModel, MessageModel } from "../../model/NotificationModel";

export interface NotificationState {
    loading: boolean;
    error: boolean;
    data: Array<NotificationModel>;
    readData: Array<NotificationModel>;
    loadingRenew: boolean;
    errorRenew: boolean;
    loadingGet: boolean;
    errorGet: boolean;
    item: MessageModel;
}

export const initialState: NotificationState = {
    loading: false,
    error: false,
    data: [],
    readData: [],
    loadingRenew: false,
    errorRenew: false,
    loadingGet: false,
    errorGet: false,
    item: null
}


// WEBPACK FOOTER //
// ./src/store/state/NotificationState.ts